<template>
    <div
        class="max-w-xl mx-auto"
        v-on-interaction="
            () => {
                remainingRefreshSessionCount = 20;
            }
        "
    >
        <bubbleBox
            v-if="success"
            :greetText="'成功登記新公司'"
            :greetTextClass="'text-darkGrayishBlue font-bold text-xl'"
            class="mb-8 mt-4"
            :image="img2s112"
        >
            <div class="flex flex-col p-2 text-darkGrayishBlue text-xl">
                <div class="self-center font-bold text-2xl sm:text-3xl mb-2">
                    {{ cmpyName }}
                </div>
                <template v-if="accountCreationUrl">
                    <div class="mb-2">
                        請公司聯絡人經以下 QR Code 啟動帳號：
                    </div>
                    <a
                        target="_blank"
                        :href="accountCreationUrl"
                        class="flex flex-col self-center"
                    >
                        <qrcode
                            :value="accountCreationUrl"
                            :options="{ width: 300 }"
                            class="self-center"
                        />
                    </a>
                </template>
                <div class="mb-2">
                    {{
                        !hasQuickJoinShopList
                            ? '注意: 此公司尚未加入任何Shopping List，請用以下 QR Code 。'
                            : sendEmailSuccess
                            ? '邀請電郵已經發送至公司聯絡人。請邀請公司聯絡人將電郵轉發給其他同事登記會員。'
                            : '未能發送電郵，請用以下 QR Code 。'
                    }}
                </div>
                <div class="flex flex-col">
                    <div>
                        此公司的專享購物連結：
                    </div>
                    <a
                        target="_blank"
                        :href="cmpyPreviewProductsUrl"
                        class="flex flex-col self-center"
                    >
                        <qrcode
                            :value="cmpyPreviewProductsUrl"
                            :options="{ width: 300 }"
                            class="self-center"
                        />
                    </a>
                </div>
                <div class="self-end text-blue underline" @click="restart">
                    返回登記新公司
                </div>
            </div>
        </bubbleBox>
        <div v-else>
            <bubbleBox
                :greetText="'登記新公司'"
                :greetTextClass="'text-darkGrayishBlue'"
                class="mb-8 mt-4"
                :image="img7s112"
            >
                <form
                    class="text-lg py-8 px-4 sm:pt-8 sm:pb-4 sm:px-8"
                    autocomplete="off"
                >
                    <formFieldRow
                        name="companyName"
                        :label="'公司名稱(簡稱)'"
                        :required="true"
                        labelWidthClass="sm:w-40 font-bold text-darkGrayishBlue"
                        :errors="errors"
                    >
                        <template #default="{hasError}">
                            <input
                                name="companyName"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="text"
                                autocomplete="off"
                                v-model.trim="form.companyName"
                                @keydown.enter="$refs.password.focus"
                            />
                        </template>
                    </formFieldRow>
                    <formFieldRow
                        name="controllerName"
                        :label="'聯絡人姓名'"
                        :required="true"
                        labelWidthClass="sm:w-40 font-bold text-darkGrayishBlue"
                        :errors="errors"
                    >
                        <template #default="{hasError}">
                            <input
                                name="controllerName"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="text"
                                autocomplete="off"
                                v-model.trim="form.controllerName"
                                @keydown.enter="$refs.password.focus"
                            />
                        </template>
                    </formFieldRow>
                    <formFieldRow
                        name="controllerEmail"
                        :label="'聯絡人電郵'"
                        :required="true"
                        labelWidthClass="sm:w-40 font-bold text-darkGrayishBlue"
                        :errors="errors"
                    >
                        <template #default="{hasError}">
                            <input
                                name="controllerEmail"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="email"
                                autocomplete="off"
                                v-model.trim="form.controllerEmail"
                                @keydown.enter="$refs.password.focus"
                            />
                        </template>
                    </formFieldRow>
                    <formFieldRow
                        name="controllerConfirmEmail"
                        :label="'確認電郵'"
                        :required="true"
                        labelWidthClass="sm:w-40 font-bold text-darkGrayishBlue"
                        :errors="errors"
                    >
                        <template #default="{hasError}">
                            <input
                                name="controllerConfirmEmail"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="email"
                                autocomplete="off"
                                v-model.trim="form.controllerConfirmEmail"
                                @keydown.enter="$refs.password.focus"
                            />
                        </template>
                    </formFieldRow>
                    <formFieldRow
                        name="controllerPhoneNumber"
                        :label="'聯絡人電話'"
                        labelWidthClass="sm:w-40 font-bold text-darkGrayishBlue"
                        :errors="errors"
                    >
                        <template #default="{hasError}">
                            <input
                                name="controllerPhoneNumber"
                                class="form-input"
                                :class="{ 'border-red': hasError }"
                                type="tel"
                                autocomplete="off"
                                v-model.trim="form.controllerPhoneNumber"
                                @keydown.enter="$refs.password.focus"
                            />
                        </template>
                    </formFieldRow>
                </form>
            </bubbleBox>
            <loadingButton
                class="mt-2 py-2 px-8 bg-primary font-black w-full justify-center rounded border border-blue text-center"
                :status="status"
                @click="submit"
                ref="submitButton"
            >
                {{ '登記新公司' }}
            </loadingButton>
            <errorBox class="text-sm" :message="errors.server" />
            <div class="flex mt-2">
                <button
                    class="ml-auto text-blue py-2 focus:outline-none focus:text-darkGrayishBlue underline"
                    @click="clearForm"
                >
                    {{ '重新輸入' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import loadingButton from '@/components/loadingButton.vue';
import bubbleBox from '@/components/bubbleBox.vue';
import formFieldRow from '@/components/formFieldRow.vue';
import { validate } from '@/utils/validationUtil';
import errorBox from '@/components/errorBox.vue';
// import { wait } from '@/utils/promiseUtil';
import img2s112 from '@/assets/img/2-112.png';
import img7s112 from '@/assets/img/7-112.png';
import { instance } from '@/utils/ajax';
import qrcode from '@/components/qrcode.vue';
import onInteraction from '@/directives/onInteraction';

function getUUIDByTimestampAndPageLoadedDuration() {
    var d = new Date().getTime(); //Timestamp
    var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}

async function refreshBofLoginSession() {
    try {
        await instance.get('/api/quickJoinCmpy/bofAlive');
    } catch (e) {
        /* eslint-disable no-console */
        console.error('ping alive failed, will be redirected');
    }
}

export default {
    components: {
        formFieldRow,
        loadingButton,
        bubbleBox,
        errorBox,
        qrcode
    },
    directives: { onInteraction },
    data() {
        return {
            form: {
                companyEmailTokenNumber: getUUIDByTimestampAndPageLoadedDuration(),
                companyName: undefined,
                controllerName: undefined,
                controllerEmail: undefined,
                controllerConfirmEmail: undefined,
                controllerPhoneNumber: undefined
            },
            errors: {},
            status: undefined,
            recaptchaError: false,
            success: false,
            sendEmailSuccess: false,
            hasQuickJoinShopList: false,
            cmpyPreviewProductsUrl: undefined,
            accountCreationUrl: undefined,
            cmpyName: undefined,
            remainingRefreshSessionCount: 20,
            refreshSessionInterval: undefined
        };
    },
    created() {
        this.img2s112 = img2s112;
        this.img7s112 = img7s112;
        this.refreshSessionInterval = setInterval(async () => {
            await refreshBofLoginSession();
            if (this.remainingRefreshSessionCount > 0) {
                this.remainingRefreshSessionCount--;
            } else {
                clearInterval(this.refreshSessionInterval);
            }
        }, 5 * 60 * 1000);
    },
    beforeDestroy() {
        if (this.refreshSessionInterval)
            clearInterval(this.refreshSessionInterval);
    },
    methods: {
        clearForm() {
            this.form = {
                companyEmailTokenNumber: getUUIDByTimestampAndPageLoadedDuration(),
                companyName: undefined,
                controllerName: undefined,
                controllerEmail: undefined,
                controllerConfirmEmail: undefined,
                controllerPhoneNumber: undefined
            };
        },
        restart() {
            this.clearForm();
            this.success = false;
            this.sendEmailSuccess = false;
            this.hasQuickJoinShopList = false;
            this.cmpyName = undefined;
            this.cmpyPreviewProductsUrl = undefined;
            this.accountCreationUrl = undefined;
            this.status = undefined;
        },
        async submit() {
            this.errors = {};
            this.recaptchaError = false;
            const v = validate(this.errors, this.form, {
                companyName: { required: true },
                controllerName: { required: true },
                controllerEmail: { required: true },
                controllerConfirmEmail: {
                    required: true,
                    sameValidator: function(val, d) {
                        if (val !== d.controllerEmail) {
                            return 'error.confirm.email.not.equal';
                        }
                    }
                }
            });
            if (v.hasError) {
                this.errors = v.errors;
                return;
            }

            this.status = 'loading';
            const result = await instance.post(
                '/api/quickJoinCmpy/aplyCmpy',
                this.form
            );

            if (result.data.success) {
                this.success = true;
                this.sendEmailSuccess = result.data.data.sendEmailSuccess;
                this.hasQuickJoinShopList =
                    result.data.data.hasQuickJoinShopList;
                this.cmpyName = result.data.data.cmpyName;
                this.cmpyPreviewProductsUrl = `${location.origin}${process.env.BASE_URL}previewProducts/${result.data.data.cmpyEmailTknNum}`;
                this.accountCreationUrl = `${location.origin}${process.env.BASE_URL}register/${result.data.data.acctCreTxnNum}`;

                this.status = 'success';
            } else {
                this.status = undefined;
                if (result.data.data.recaptchaError) {
                    this.recaptchaError = true;
                    this.$refs.recaptcha.reset();
                }
                if (result.data.data.errors) {
                    this.errors = result.data.data.errors;
                }
            }
        }
    }
};
</script>
